export default {
      id: "more-vertical-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#more-vertical-usage",
      toString: function () {
        return this.url;
      }
    }